import React from 'react';
import { Input, Space } from 'antd';
import styles from '../../../event-timeline.module.css';

const { TextArea } = Input;

interface CustomParamsProps {
  params: any;
  setParams: (params: any) => void;
}

const CustomParams: React.FC<CustomParamsProps> = ({ params, setParams }) => {
  return (
    <div className={styles.parameterContainer}>
      <Space direction='vertical' style={{ width: '100%' }}>
        <span>Custom Parameters (JSON):</span>
        <TextArea
          value={JSON.stringify(params, null, 2)}
          onChange={(e) => {
            try {
              setParams(JSON.parse(e.target.value));
            } catch (error) {
              console.error('Invalid JSON:', error);
            }
          }}
          placeholder='Enter custom parameters as JSON'
          rows={4}
        />
      </Space>
    </div>
  );
};

export default CustomParams;
